import axios from 'axios';
const baseDomain = process.env.REACT_APP_BASE_URL || 'https://dev-api-nurse.scapp.work'
export const customHeader = {
    'Content-Type': 'application/json',
    Accept: 'application/json'
};

export const baseUrl = `${ baseDomain }`;
export const baseFile = process.env.REACT_APP_BASE_DEV_TOOL || 'https://dev-tools-nurse.scapp.work';
export const currentDemo = 4;

export default axios.create( {
    baseUrl,
    headers: customHeader
} )
